import { inject } from "mobx-react";
import React from "react";
import { CreateView, IndexView, Schema } from "lego-gui-lib/lib";
import { GroupAreaColumns, GroupAreaCreateSchema } from "./schema";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";

const injectDataSource = (comp: any) =>
  inject(
    "areaSplitting",
    "areaSplittingGroupArea",
    "auth",
    "language",
    "i18n"
  )(observer(comp));

export const GroupAreaCreate = injectDataSource(
  ({ areaSplittingGroupArea, i18n, match, ...rest }: any) => {
    const history = useHistory();
    const title = i18n.t("common:create", {
      domain: "hns:areaSplittingGroup:area:domain"
    });

    const schema: Schema = GroupAreaCreateSchema;
    const id = {
      id: match.params.areaId
    };

    return (
      <CreateView
        dataSource={areaSplittingGroupArea.oneDataSource}
        title={title}
        {...rest}
        goBack={() => {
          history.goBack();
        }}
        fields={schema}
        id={id.id ? id : undefined}
      />
    );
  }
);

const toolbarButtons = (allowed: boolean) => {
  return allowed
    ? { delete: true, export: false }
    : { delete: false, export: false };
};

const titleButtons = (allowed: boolean) => (props: any) => {
  if (allowed) {
    return undefined;
  } else {
    return <></>;
  }
};

export const GroupAreaIndex = injectDataSource((props: any) => {
  const { areaSplittingGroupArea, i18n, auth, ...rest } = props;
  const title = i18n.t("hns:areaSplittingGroup:area:domain_plural");

  return (
    <IndexView
      dataSource={areaSplittingGroupArea.listDataSource}
      {...rest}
      titleButtons={titleButtons(props.isAllowed)}
      toolbarButtons={toolbarButtons(props.isAllowed)}
      rowButtons={{
        edit: false,
        delete: props.isAllowed,
        copy: false,
        export: false
      }}
      title={title}
      baseUrl="/areas"
      columns={GroupAreaColumns}
    />
  );
});
